export default __webpack_public_path__ + "static/media/overview.fa4c7d11.svg";